module.exports = __webpack_public_path__ + "static/media/3-BRILLTER.ee00489e.mp3";